import { render, staticRenderFns } from "./resetRegister.vue?vue&type=template&id=b40e6e5a&"
import script from "./resetRegister.vue?vue&type=script&lang=js&"
export * from "./resetRegister.vue?vue&type=script&lang=js&"
import style0 from "./resetRegister.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports